// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateField .css-1q6at85-MuiInputBase-root-MuiOutlinedInput-root {
  height: 5vh;
  width: 187px;
}

.css-1jdq69z-MuiFormControl-root-MuiTextField-root {
  width: 187px;
}

.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {
  height: 4vh;
  width: 104px;
}

.css-e4w4as-MuiFormLabel-root-MuiInputLabel-root {
  transform: translate(12px, 7px) scale(0.75) !important;
}

.css-14x1nlk {
  transform: translate(12px, 7px) scale(0.75) !important;
}

.statement-container {
  width: 82%;
  margin-left: 18%;
  min-width: 0;
  box-sizing: border-box;
}
@media (max-width: 1024px) {
  .statement-container {
    width: 72% !important;
    margin-left: 28% !important;
  }
}
@media (max-width: 600px) {
  .statement-container {
    width: calc(100% - 180px) !important;
    margin-left: 180px !important;
  }
}
.statement-container .statement-top-bar {
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 12px;
  box-sizing: border-box;
}
.statement-container .statement-top-bar .searchbox-button-container {
  width: min(245px, 100%);
  height: auto;
  margin-top: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
}
.statement-container .statement-top-bar .searchbox-button-container .textfield,
.statement-container .statement-top-bar .searchbox-button-container .MuiTextField-root,
.statement-container .statement-top-bar .searchbox-button-container .button,
.statement-container .statement-top-bar .searchbox-button-container .MuiButton-root {
  width: 100% !important;
  max-width: 245px;
  height: auto;
}
.statement-container .statement-filters {
  width: 100%;
  margin: 12px 0 0;
  padding: 12px 16px;
  box-sizing: border-box;
  background-color: #dbdbdb;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-end;
  gap: 16px;
}
.statement-container .statement-filters .MuiFormControl-root,
.statement-container .statement-filters .MuiTextField-root {
  width: min(220px, 100%);
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Statements/style.scss"],"names":[],"mappings":"AACI;EACI,WAAA;EACA,YAAA;AAAR;;AAKA;EACI,YAAA;AAFJ;;AAKA;EACI,WAAA;EACA,YAAA;AAFJ;;AAKA;EACI,sDAAA;AAFJ;;AAKA;EACI,sDAAA;AAFJ;;AAKA;EACI,UAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;AAFJ;AAII;EANJ;IAOQ,qBAAA;IACA,2BAAA;EADN;AACF;AAGI;EAXJ;IAYQ,oCAAA;IACA,6BAAA;EAAN;AACF;AAEI;EACI,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;AAAR;AAEQ;EACI,uBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,QAAA;AAAZ;AAEY;;;;EAII,sBAAA;EACA,gBAAA;EACA,YAAA;AAAhB;AAKI;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,4BAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,qBAAA;EACA,SAAA;AAHR;AAKQ;;EAEI,uBAAA;EACA,eAAA;AAHZ","sourcesContent":[".DateField {\r\n    .css-1q6at85-MuiInputBase-root-MuiOutlinedInput-root {\r\n        height: 5vh;\r\n        width: 187px;\r\n    }\r\n}\r\n\r\n\r\n.css-1jdq69z-MuiFormControl-root-MuiTextField-root {\r\n    width: 187px;\r\n}\r\n\r\n.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {\r\n    height: 4vh;\r\n    width: 104px;\r\n}\r\n\r\n.css-e4w4as-MuiFormLabel-root-MuiInputLabel-root {\r\n    transform: translate(12px, 7px) scale(0.75) !important;\r\n}\r\n\r\n.css-14x1nlk {\r\n    transform: translate(12px, 7px) scale(0.75) !important;\r\n}\r\n\r\n.statement-container {\r\n    width: calc(100% - 18%);\r\n    margin-left: 18%;\r\n    min-width: 0;\r\n    box-sizing: border-box;\r\n\r\n    @media (max-width:1024px) {\r\n        width: calc(100% - 28%) !important;\r\n        margin-left: 28% !important;\r\n    }\r\n\r\n    @media (max-width: 600px) {\r\n        width: calc(100% - 180px) !important;\r\n        margin-left: 180px !important;\r\n    }\r\n\r\n    .statement-top-bar {\r\n        flex-direction: row;\r\n        flex-wrap: wrap;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        width: 100%;\r\n        gap: 12px;\r\n        box-sizing: border-box;\r\n\r\n        .searchbox-button-container {\r\n            width: min(245px, 100%);\r\n            height: auto;\r\n            margin-top: 0;\r\n            display: flex;\r\n            flex-direction: column;\r\n            justify-content: space-between;\r\n            gap: 8px;\r\n\r\n            .textfield,\r\n            .MuiTextField-root,\r\n            .button,\r\n            .MuiButton-root {\r\n                width: 100% !important;\r\n                max-width: 245px;\r\n                height: auto;\r\n            }\r\n        }\r\n    }\r\n\r\n    .statement-filters {\r\n        width: 100%;\r\n        margin: 12px 0 0;\r\n        padding: 12px 16px;\r\n        box-sizing: border-box;\r\n        background-color: #dbdbdb;\r\n        border-top-left-radius: 10px;\r\n        border-top-right-radius: 10px;\r\n        display: flex;\r\n        flex-direction: row;\r\n        flex-wrap: wrap;\r\n        justify-content: center;\r\n        align-items: flex-end;\r\n        gap: 16px;\r\n\r\n        .MuiFormControl-root,\r\n        .MuiTextField-root {\r\n            width: min(220px, 100%);\r\n            max-width: 100%;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
